import React from "react";

function Input({
  title,
  type,
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  touched,
  errors,
}) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="english" className="text-gray-700 font-medium">
        {title}
      </label>
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`h-12 border ${
          touched && errors ? "border-red-500" : "border-gray-300"
        } rounded-md px-4 text-lg focus:outline-none focus:ring-2 focus:ring-purple-500 outline-none`}
        placeholder={placeholder}
      />
      {touched && errors && (
        <p className="text-sm text-red-500 mt-1">{errors}</p>
      )}
    </div>
  );
}

export default Input;
